export default __webpack_public_path__ + "static/media/img-05.ac88d200.jpg";